module.exports = __webpack_public_path__ + "static/media/horse.7bec0391.png";